import {Link} from 'react-router-dom'
import pic from './logo.png' 
import './App.css'
function Header(){
return(
    <div >
         <nav className = "navbar navbar-expand-sm bg-dark navbar-dark ">
            <navbrand> 
               <Link to="/"><img className='logo' src={pic} alt="this is a logo"/></Link>
            </navbrand>
            <ul className = "navbar-nav m-auto ">
               <li className = "nav-item active">
                  <Link className = "nav-link text-warning" to = "/">Home 
                     <span className = "sr-only">(current)</span>
                  </Link>
               </li>
               <li className = "nav-item">
                  <Link className = "nav-link text-warning" to= "/about">About Us</Link>
               </li>
               <li className = "nav-item">
                  <Link className = "nav-link text-warning" to= "/contact">Contact</Link>
               </li>
               <li className = "nav-item ml-5">
                  <Link className = "nav-link text-warning" to= "/game"><button className='btn btn-warning'>Have fun, play game!</button></Link>
               </li>
            </ul>
            
         </nav>
        
    </div>
)


}


export default Header;